var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "info_svg__icon--info",
    viewBox: "0 0 43 43"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21.5 3.44c9.974 0 18.06 8.086 18.06 18.06S31.474 39.56 21.5 39.56 3.44 31.474 3.44 21.5 11.526 3.44 21.5 3.44m0 2.164c-8.779 0-15.896 7.117-15.896 15.896S12.721 37.396 21.5 37.396 37.396 30.279 37.396 21.5 30.279 5.604 21.5 5.604m.226 11.381c.612 0 1.11.458 1.128 1.028v13.263c0 .586-.505 1.06-1.128 1.06-.613 0-1.11-.458-1.129-1.028V18.045c0-.586.505-1.06 1.129-1.06m0-6.772a2.032 2.032 0 1 1 0 4.063 2.032 2.032 0 0 1 0-4.063"
  })));
};
export default SvgInfo;